<template>
  <!-- 多张图片的上传组合 -->
  <div class="noalone-box">
    <div
      class="items"
      v-for="(file, index) in fileListFilter"
      :key="file.uid"
    >
      <EnlargeImg :imgSrc="file.url" class="avatar" />
      <img
        :src="closeImg"
        v-if="file.status === 'success'"
        class="_close"
        @click.stop="deleteUploadHandle(index)"
      />
      <p class="upload-text" v-if="isShowTitle">
        <span :title="file.title">{{ file.title }}</span>
        <i
          v-if="isShowCustom"
          class="el-icon-edit-outline edit-icon"
          @click="editTxt(index)"
        ></i>
      </p>
      <div
        class="progress-box"
        v-if="file.status === 'ready' || file.status === 'uploading'"
      >
        <!-- 上传中··· -->
        <div class="progress-item">
          <el-progress
            type="circle"
            :width="50"
            :show-text="true"
            :stroke-width="4"
            :percentage="file.percentage"
          />
        </div>
      </div>
    </div>
    <slot name="coreUpload">
    </slot>
  </div>
</template>

<script>
export default {
  name: 'NoAloneBox',
  data() {
    return {}
  },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    isShowTitle: {
      type: Boolean,
      default: false,
    },
    isShowCustom: {
      type: Boolean,
      default: false,
    },
    closeImg: {
      type: String,
      default: '',
    },
  },
  methods: {
    deleteUploadHandle(index) {
      this.$emit('deleteUploadHandle', index)
    },

    editTxt(index) {
      this.$emit('editTxt', index)
    },

  },
  computed: {
    // 上传文件数据处理，过滤掉数组中不是对象或者是对象且无属性的元素
    fileListFilter() {
      // 判断类型是不是数组
      const result = Array.isArray(this.fileList) ? this.fileList : []
      return result.filter((item) => Object.prototype.toString.call(item) === '[object Object]' && Object.keys(item).length !== 0)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../index.scss';
</style>
